module.exports = __webpack_public_path__ + "static/img/car_bg.fec9cff7.png";